import {
  BaSeDatePicker,
  BaSeInput,
  BaSeParagraph,
  BaSeTheme,
} from '@base/react';
import React from 'react';
import {
  AlignHeaderContainer,
  HeaderContainer,
} from './modal-generate-certificate-style';

function FormHeaderGenerateCertificate({
  setCargaHoraria,
  setInitialDate,
  initialDate,
  setFinalDate,
  finalDate,
  cargaHoraria,
}) {
  const handleChangeWorkload = React.useCallback(
    (e) => {
      if (isNaN(+e) || e.includes('.') || e.includes(' ')) {
        return;
      }
      setCargaHoraria(e);
    },
    [setCargaHoraria],
  );

  return (
    <HeaderContainer>
      <BaSeParagraph color={BaSeTheme.colors.institucionais.cinzaSebrae45}>
        Lista de candidato(s) selecionado(s) para geração de certificado(s)
      </BaSeParagraph>
      <AlignHeaderContainer>
        <>
          <BaSeDatePicker
            startDate={initialDate}
            label="Data do Seminário"
            onStartDateChange={setInitialDate}
            onBlur={(e) => {
              setInitialDate((date) => date);
            }}
            onSelect={(date) => {
              setInitialDate(date);
            }}
            placeholder="Data de início"
          />

          <BaSeDatePicker
            startDate={finalDate}
            isDisabled={!initialDate}
            minDate={
              new Date(
                new Date(initialDate).setDate(
                  new Date(initialDate).getDate() + 1,
                ),
              )
            }
            onStartDateChange={setFinalDate}
            onBlur={(e) => {
              setFinalDate((date) => date);
            }}
            onSelect={(date) => {
              setFinalDate(date);
            }}
            placeholder="Data de término"
            label="  "
          />
        </>

        <div>
          <BaSeInput
            suffix=" horas"
            label="Carga horária"
            placeholder={`${cargaHoraria} horas`}
            value={cargaHoraria}
            onChange={handleChangeWorkload}
            inputMode="decimal"
            maxLength={9}
          />
        </div>
      </AlignHeaderContainer>
    </HeaderContainer>
  );
}

export default FormHeaderGenerateCertificate;
